import React, { useState } from "react";
import exploreEvents from "../../../../assets/images/others/host-side-images/exploreEvents.png";
import locationIcon from "../../../../assets/images/svgs/locationIcon.svg";
import iconOne from "../../../../assets/images/svgs/iconOne.svg";
import iconTwo from "../../../../assets/images/svgs/iconTwo.svg";
import iconThree from "../../../../assets/images/svgs/iconThree.svg";
import { useNavigate } from "react-router-dom";

export type Experience = {
  id: number;
  date: string;
  month: string;
  title: string;
  location: string;
  attendees: number;
  image: string;
  attendeesAvatars: string[];
  category: string; // "Workshop" or "Session"
  timeFilter: "This Week" | "This Month" | "";
  dateStatus: "Upcoming" | "Past";
};

// Dummy data for events (including both upcoming and past)
const experiences: Experience[] = [
  {
    id: 1,
    date: "10",
    month: "JUNE",
    title: "How to Improve Your Communication and Social Life",
    location: "Radius Gallery • Santa Cruz, CA",
    attendees: 20,
    image: exploreEvents,
    attendeesAvatars: [iconOne, iconTwo, iconThree],
    category: "Workshop",
    timeFilter: "This Week",
    dateStatus: "Upcoming",
  },
  {
    id: 2,
    date: "12",
    month: "JULY",
    title: "Networking for Young Professionals",
    location: "Downtown Hub • New York, NY",
    attendees: 35,
    image: exploreEvents,
    attendeesAvatars: [iconOne, iconTwo, iconThree],
    category: "Session",
    timeFilter: "This Month",
    dateStatus: "Upcoming",
  },
  {
    id: 3,
    date: "15",
    month: "JUNE",
    title: "Public Speaking Essentials",
    location: "Community Center • Chicago, IL",
    attendees: 25,
    image: exploreEvents,
    attendeesAvatars: [iconOne, iconTwo, iconThree],
    category: "Workshop",
    timeFilter: "This Month",
    dateStatus: "Upcoming",
  },
  {
    id: 4,
    date: "20",
    month: "JULY",
    title: "Mastering Leadership Skills",
    location: "Tech Hub • San Francisco, CA",
    attendees: 30,
    image: exploreEvents,
    attendeesAvatars: [iconOne, iconTwo, iconThree],
    category: "Session",
    timeFilter: "This Week",
    dateStatus: "Upcoming",
  },
  // Past experiences dummy data
  {
    id: 5,
    date: "05",
    month: "MAY",
    title: "Past Workshop Event",
    location: "Old Venue • Boston, MA",
    attendees: 40,
    image: exploreEvents,
    attendeesAvatars: [iconOne, iconTwo, iconThree],
    category: "Workshop",
    timeFilter: "This Week",
    dateStatus: "Past",
  },
  {
    id: 6,
    date: "08",
    month: "APRIL",
    title: "Past Session Event",
    location: "Historic Hall • Los Angeles, CA",
    attendees: 50,
    image: exploreEvents,
    attendeesAvatars: [iconOne, iconTwo],
    category: "Session",
    timeFilter: "This Month",
    dateStatus: "Past",
  },
];

/** AttendeExperiences Component */
const Experiences = () => {
  const navigate = useNavigate();

  // Upcoming filters
  const [selectedUpcomingCategory, setSelectedUpcomingCategory] =
    useState<string>("All");

  // Filter upcoming experiences based on upcoming filters
  const filteredUpcoming = experiences.filter(
    (exp) =>
      exp.dateStatus === "Upcoming" &&
      (selectedUpcomingCategory === "All" ||
        exp.category === selectedUpcomingCategory)
  );

  return (
    <div className=" ">
      <div className="flex flex-wrap items-center justify-between gap-5">
        <div className="flex flex-wrap gap-5 py-3">
          <div className="flex space-x-4 md:space-x-10 pb-2">
            {["All", "Past", "Upcoming"].map((tab) => (
              <button
                key={tab}
                className={`text-base font-semibold pb-1 ${
                  selectedUpcomingCategory === tab
                    ? "text-lightBlueColor border-b-2 border-lightBlueColor"
                    : "text-grayText hover:text-lightBlueColor"
                }`}
                onClick={() => setSelectedUpcomingCategory(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Upcoming Experiences Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-4">
        {filteredUpcoming.map((exp) => (
          <div
            key={exp.id}
            className="p-3 bg-white rounded-xl border border-borderColor cursor-pointer"
          >
            <div className="relative">
              <img
                src={exp.image}
                alt={exp.title}
                className="w-full h-32 object-cover rounded-xl"
              />
              <div className="absolute top-2 left-2 bg-white text-center p-2 rounded-md">
                <span className="block text-sm font-bold text-primaryBlueText">
                  {exp.date}
                </span>
                <span className="block text-xs text-primaryBlueText">
                  {exp.month}
                </span>
              </div>
            </div>
            <div className="py-2">
              <h3 className="text-lg font-semibold text-blackie">
                {exp.title}
              </h3>
              <div className="flex items-center mt-2">
                <div className="flex -space-x-2">
                  {exp.attendeesAvatars.map((avatar, index) => (
                    <img
                      key={index}
                      src={avatar}
                      alt="Attendee"
                      className="w-7 h-7 rounded-full border-2 border-white"
                    />
                  ))}
                </div>
                <span className="ml-2 text-sm text-darkYellowText">
                  +{exp.attendees} Going
                </span>
              </div>
              <p className="text-base text-[#807A7A] mt-2 flex items-center gap-2">
                <img src={locationIcon} alt="Location" /> {exp.location}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experiences;
